import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { bmxurl } from 'src/globals';
import { tillproductoptions } from 'src/types/tillproductoptions';
import { cTillproduct } from 'src/types/tillproduct';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../../_services/global.service';

export interface OptionRow {
  option: tillproductoptions;
  selected: boolean;
}

@Component({
  selector: 'app-tillproductoptionsassign',
  templateUrl: './tillproductoptionsassign.component.html',
  styleUrls: ['./tillproductoptionsassign.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TillproductoptionsassignComponent implements OnInit {
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  httpResponse: any;
  productId: string;
  productName: string = '';
  product: cTillproduct;
  optionRows: OptionRow[] = [];
  pageReady: boolean = false;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;

  availabilityOptions: any[] = [
    { label: 'Available', value: true },
    { label: 'Not Available', value: false }
  ];

  CurrencySymbol: string = localStorage.getItem("Currency") ?? "GBP";

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private messageService: MessageService,
    private globalService: GlobalService
  ) {}

  ngOnInit(): void {
    this.globalService.setSmallScreenMenu(false);
    this.productId = this.route.snapshot.paramMap.get('productid');

    const userid = localStorage.getItem("SmartUserID");
    this.http.get(bmxurl + "User/" + userid).subscribe({
      next: (response: any) => {
        this.httpResponse = response as users_returndata;
        if (this.httpResponse.succeeded) {
          this.AccessAllowed = true;
          this.loadData();
        }
        this.CompletedLoading = true;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while getting User' });
      }
    });
  }

  loadData(): void {
    // Load the product and all global options in parallel
    this.http.get(bmxurl + "TillProduct/" + this.VenueID + "/" + this.productId).subscribe({
      next: (res: any) => {
        if (res.succeeded) {
          const rawData = res.data;
          const data = Array.isArray(rawData) ? rawData[0] : rawData;
          if (data) {
            this.product = data as cTillproduct;
            this.productName = this.product.name;
            this.loadAllOptions();
          }
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not load product' });
        }
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not load product' });
      }
    });
  }

  loadAllOptions(): void {
    this.http.get(bmxurl + "TillProductOptionsList/" + this.VenueID + "/false").subscribe({
      next: (res: any) => {
        if (res.succeeded) {
          const allOptions: tillproductoptions[] = res.data ?? [];
          const assignedIds = new Set((this.product.options ?? []).map(o => o.id));

          this.optionRows = allOptions.map(opt => ({
            option: opt,
            selected: assignedIds.has(opt.id)
          }));

          this.pageReady = true;
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not load options' });
        }
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not load options' });
      }
    });
  }

  saveAssignments(): void {
    this.product.options = this.optionRows
      .filter(r => r.selected)
      .map(r => r.option);

    this.http.put(bmxurl + "TillProduct", this.product).subscribe({
      next: (response: any) => {
        this.httpResponse = response;
        if (this.httpResponse.succeeded) {
          this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Product options updated' });
          this.router.navigateByUrl("/tillproductedit/" + this.productId);
        } else {
          this.messageService.add({ severity: 'error', summary: 'Not Saved', detail: this.httpResponse.messages?.[0] ?? 'Save failed' });
        }
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Not Saved', detail: 'Error saving product options' });
      }
    });
  }

  cancel(): void {
    this.router.navigateByUrl("/tillproductedit/" + this.productId);
  }
}
